import { WhiteScreenDetector, Mfe, Env } from '@nio-pow/mfe-vue3'


const blackModuleList = [ 'bohu']

const whiteScreenDetector = new WhiteScreenDetector({
  debug: true,
  maxLoopCount: 8,
  whiteBoxElements: ['.pe-layout-pc-wrapper', '.pe-frame-container']
})

export const startWhiteScreenDetector = () => {
  // 海外暂时不开启白屏检测
  if (Env.isInternational()) {
    return
  }
  let timer: any = null
  // 如果进入系统第一次也是黑名单，主应用也无需检测
  const firstModule =  Mfe.getMicroAppByPath(location.pathname)?.activeRule?.split('/').pop()
  if(!blackModuleList.includes(firstModule)) {
    whiteScreenDetector.detect({ module: firstModule || 'powerpro' }, (res: any) => {
      console.log('主应用白屏检测结果', res)
    })
  }
  window.addEventListener('popstate', () => {
    // 延迟执行
    if(timer) {
      clearTimeout(timer)
      timer = null
    }
    timer = setTimeout(() => {
      const currentApp = Mfe.getMicroAppByPath(location.pathname)
      const currentModule = currentApp?.activeRule?.split('/').pop()
      if(blackModuleList.includes(currentModule)) {
        return
      }
      whiteScreenDetector.detect({ module: currentModule }, (res: any) => {
        console.log( `子应用${currentModule}白屏检测结果`, res)
      })
    }, 1000)
  })
}
